import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { DestroyOptions } from "pixi.js";
import { landscapeLogoPositions, portraitLogoPositions } from "../../config/GlobalVariableConfig";
import { VISIBLE_SYMBOLS_PER_REEL } from "../../config/reelConfig";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";

export class Logo extends DisplayObject {
    private logo: Spine | null = null;

    constructor(config: IDisplayObject) {
        super(config);
        this.init();
    }

    public override destroy(options?: DestroyOptions): void {
        super.destroy(options);
    }

    public playIdle() {
        this.logo.state.setAnimation(0, "logo", true);
    }

    public playWin() {
        this.logo.state.setAnimation(0, "logo", true);
    }

    public override setPositionResize(orientation: string) {
        const symbolCount = VISIBLE_SYMBOLS_PER_REEL;
        const index = symbolCount - 3;

        if (orientation === "LANDSCAPE") {
            const pos = landscapeLogoPositions()[index][symbolCount];
            this.setPosition(pos.posX, pos.posY);
            this.setScale(this.config.landscape.scale, this.config.landscape.scale);
        } else {
            const pos = portraitLogoPositions[index][symbolCount];
            this.setPosition(pos.posX, pos.posY);
            this.setScale(this.config.portrait.scale, this.config.portrait.scale);
        }
    }

    private init(): void {
        this.logo = Spine.from({
            skeleton: "logoSkel",
            atlas: "logoAtlas",
        });
        this.logo.label = "logo";
        this.addChild(this.logo);
        this.logo.state.setAnimation(0, "logo", true);
    }
}
